module.exports = __webpack_public_path__ + "img/157.7d39959b.jpg";